module.exports = __webpack_public_path__ + "static/media/SubmitLead.ca8252ca.png";